<template>
  <v-flex fill fill-height horizontal>
    <div class="text-xs-center" v-if="loading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <section v-if="!loading" class="elevation-1 week-score-cards">
      <div
        v-sticky="stickyConfig"
        style="background:white"
        class="table-header-section"
      >
        <v-container fluid grid-list-xs style="padding: 5px">
          <v-layout row wrap>
            <v-flex xs2>
              <v-select
                v-model="workingData.season"
                :items="seasons"
                item-text="name"
                label="Season"
                :auto-select-first="true"
                :return-object="true"
                dense
              >
              </v-select>
            </v-flex>
            <v-flex xs2 offset-xs1>
              <v-text-field
                v-model="workingData.week"
                label="Week"
                hint="0 for bye week"
              ></v-text-field>
            </v-flex>
            <v-flex xs2 offset-xs1>
              <v-menu
                v-model="dateMenu"
                :close-on-content-click="true"
                :nudge-right="10"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="workingData.date"
                    label="Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  scrollable
                  v-model="workingData.date"
                  @input="dateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <!--                        <v-flex xs1 text-xs-center>-->
            <!--                            <span class="caption">Cards: {{workingData.cards.length}}</span>-->
            <!--                        </v-flex>-->
            <v-flex xs4 text-xs-right>
              <v-btn
                :disabled="disableConfirmButton"
                class="primary"
                @click.stop="submit()"
              >
                <v-icon dark>cloud_upload</v-icon>&nbsp;{{
                  !isEdit ? "Create New Round" : "Update Round"
                }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        <v-data-table
          ref="headerTable"
          :headers="headers"
          :items="[]"
          hide-actions
          disable-initial-sort
          dense
        ></v-data-table>
      </div>
      <v-form ref="form" v-model="formValid" lazy-validation>
        <v-data-table
          :headers="headers"
          :items="workingData.cards"
          hide-actions
          ref="dataTable"
          class="division-table"
          disable-initial-sort
          dense
        >
          <template slot="items" slot-scope="props">
            <week-editor-row
              :item="props.index"
              :card="props.item"
              :course-meta-data="courseMetaData"
              :players="players"
              :divisions="divisions"
              :season="workingData.season"
              :onRemove="() => removeRow(props.index)"
            ></week-editor-row>
          </template>
        </v-data-table>
      </v-form>
      <v-btn @click.stop="newCard()"><v-icon>add</v-icon> New Card</v-btn>
    </section>
    <v-dialog v-model="showConfirmDialog" width="500" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ saveData.season ? saveData.season.name : "" }} - Week
          {{ saveData.week }} cards
        </v-card-title>

        <v-card-text>
          <div v-if="saveData.errorMessages && saveData.errorMessages.length">
            Found the following errors
            <ul>
              <li
                v-for="(error, idx) in saveData.errorMessages"
                v-bind:key="idx"
              >
                {{ error }}
              </li>
            </ul>
          </div>
          <div v-else>
            <p>
              Saving {{ saveData.cards ? saveData.cards.length : 0 }} cards,
              adding
              {{
                saveData.playersToCreate ? saveData.playersToCreate.length : 0
              }}
              players
            </p>
          </div>
          <v-alert :value="saveError != null" type="error">
            {{ saveError }}
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="resetConfirmDialog()">Cancel</v-btn>
          <v-btn
            flat
            @click="saveCards()"
            color="primary"
            :disabled="
              !!(saveData.errorMessages && saveData.errorMessages.length) ||
                !enableSaveButton
            "
            >Save Cards</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import VueSticky from "vue-sticky";
import metadata from "../shared/data/kentwoodMetadata";
import WeekEditorRow from "./WeekEditorRow";

export default {
  name: "WeekEditor",
  directives: {
    sticky: VueSticky,
  },
  components: {
    WeekEditorRow,
  },
  props: ["seasonId", "seasonName", "week"],
  data() {
    return {
      loading: false,
      error: null,
      formValid: true,
      dateMenu: false,
      isEdit: false,
      stickyConfig: {
        zIndex: 1,
        stickyTop: 64,
        disabled: false,
      },
      disableConfirmButton: false,
      enableSaveButton: true,
      showConfirmDialog: false,
      saveError: null,
      seasons: [],
      players: [],
      divisions: ["PRO", "ADV", "REC"],
      headers: [],
      workingData: {
        cards: [],
        season: null,
        week: null,
        date: null,
      },
      saveData: {
        cards: null,
        season: null,
        week: null,
        date: null,
        errorMessages: [],
        playersToCreate: [],
      },
      // Could be driven by course metadata from db
      courseMetaData: metadata,
    };
  },
  methods: {
    async init() {
      this.headers = [
        { text: "", value: "card_id", width: 50, sortable: false },
        { text: "Players", value: "players", sortable: false },
        { text: "Total", value: "total", width: 50, sortable: false },
        { text: "From Par", value: "total", width: 50, sortable: false },
        { text: "Winner", value: "winner", width: 50, sortable: false },
        { text: "Cashed", value: "cashed", width: 50, sortable: false },
      ];
      // reset for route change
      this.workingData = {
        cards: [],
        season: null,
        week: null,
        date: null,
      };
      await this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      this.seasons = [];

      try {
        //load drop down data
        const results = await Promise.all([
          this.$apiClient.seasons(),
          this.$apiClient.players(),
        ]);
        this.seasons = results[0].data;
        this.players = results[1].data;

        this.workingData.season = this.seasons[0];

        if (this.workingData.season.track_hole_scores) {
          this.headers = [
            { text: "", value: "card_id", width: 50, sortable: false },
            { text: "Players", value: "players", sortable: false },
            ...this.generateCard().holes.map((hole, i) => ({
              text: hole.hole,
              value: `holes[${i}].score`,
              align: "center",
              width: 31,
              sortable: false,
            })),
            { text: "Total", value: "total", width: 75, sortable: false },
            { text: "Winner", value: "winner", width: 50, sortable: false },
            { text: "Cashed", value: "cashed", width: 50, sortable: false },
          ];
        }

        // loading edit data
        this.isEdit = this.seasonId != null && this.week != null;

        if (!this.isEdit) {
          this.generateNewRound();
        } else {
          const cardResult = await this.$apiClient.weeks(
            this.seasonId,
            this.week.toLowerCase() === "bye" ? "0" : this.week
          );
          const round = cardResult.data;

          this.setRound(round);
        }
      } catch (e) {
        this.error = e;
      }

      this.loading = false;
    },
    setRound(round) {
      this.workingData.season = this.seasons.find(
        (s) => s.season_id === round.season.season_id
      );

      // add a second player for the editor
      if (this.isEdit) {
        round.cards.forEach((c) => {
          while (c.players.length < 2) {
            c.players.push(this.generateCardPlayer());
          }
        });
      }
      this.workingData.cards = round.cards;
      this.workingData.date = round.week_date.split("T")[0];
      this.workingData.week = round.week;
    },
    generateNewRound() {
      this.workingData.cards = [];
      for (let i = 0; i < 20; i++) {
        this.newCard();
      }
    },
    newCard() {
      this.workingData.cards.push(this.generateCard());
    },
    removeRow(idx) {
      this.workingData.cards.splice(idx, 1);
    },
    generateCard() {
      const holes = this.courseMetaData.holes.map((meta) => ({
        hole: meta.hole,
        score: meta.par,
      }));

      return {
        players: [this.generateCardPlayer(), this.generateCardPlayer()],
        cashed: 0,
        winner: false,
        total: this.courseMetaData.courseTotal,
        holes: holes,
      };
    },
    generateCardPlayer() {
      return { player: null, division: null };
    },
    submit() {
      this.disableConfirmButton = true;
      try {
        const cards = JSON.parse(JSON.stringify(this.workingData.cards));
        const errorMessages = [];
        const cardsToRemove = [];
        const playerCreatePromises = [];
        let foundWinner = false;
        // handle some cleanup before submitting,
        // new players and type safety
        cards.forEach((card, cardIdx) => {
          // clean up for API
          if (this.workingData.season.track_hole_scores) {
            delete card.total;
            // type the hole scores correctly
            card.holes.forEach((hole) => {
              hole.score = parseInt(hole.score);
            });
          } else {
            delete card.holes;
          }
          // edit fields
          delete card.place;
          delete card.points;
          delete card.from_par;
          delete card.players_beat;

          // create and replace any new players
          const playersToRemove = [];
          card.players.forEach((entry, playerIdx) => {
            if (entry.player === null || entry.player === "") {
              playersToRemove.push(playerIdx);
              return;
            }

            if (entry.division === null) {
              errorMessages.push(
                `Missing division for ${entry.player.name || entry.player}`
              );
            }

            // existing player selected no need to create
            if (typeof entry.player !== "string") {
              return;
            }

            // queue up all the new players, then update clone and working copy
            playerCreatePromises.push(async () => {
              const newPlayer = await this.$apiClient.createPlayer({
                name: entry.player,
                aliases: [],
              });
              // update clone
              card.players[
                card.players.findIndex((p) => p.player === entry.player)
              ].player = newPlayer.data;

              // update working copy;
              this.workingData.cards[cardIdx].players[playerIdx].player =
                newPlayer.data;
            });
          });

          if (playersToRemove.length === card.players.length) {
            cardsToRemove.push(card);
            return;
          }

          if (card.winner) {
            if (foundWinner) {
              errorMessages.unshift(
                "Please select a winner, multiple winners found"
              );
            }
            foundWinner = true;
          }

          playersToRemove.forEach((i) => card.players.splice(i, 1));
        });

        cardsToRemove.forEach((card) => {
          cards.splice(cards.indexOf(card), 1);
        });

        if (cards.length === 0) {
          errorMessages.unshift("Please fill out at least 1 card");
        } else if (!foundWinner) {
          errorMessages.unshift("Please select a winner, no winners found");
        }

        const week = parseInt(this.workingData.week);
        if (isNaN(week)) {
          errorMessages.push("Week must be a number");
        }

        if (!this.workingData.date) {
          errorMessages.push("Please set the date");
        }

        this.saveData.season = Object.assign({}, this.workingData.season);
        this.saveData.week = week;
        this.saveData.date = this.workingData.date;
        this.saveData.cards = cards;
        this.saveData.errorMessages = errorMessages;
        this.saveData.playersToCreate = playerCreatePromises;
      } catch (e) {
        this.saveData.errorMessages.push(e.toString());
      }
      this.showConfirmDialog = true;
    },
    async saveCards() {
      try {
        this.enableSaveButton = false;
        // Time to save every new player
        if (this.saveData.playersToCreate.length) {
          await Promise.all(this.saveData.playersToCreate.map((f) => f()));
        }

        // build the payload for the api
        const payload = {
          week: this.saveData.week,
          week_date: this.saveData.date,
          cards: this.saveData.cards,
        };

        // eslint-disable-next-line no-console
        console.log(JSON.stringify(payload, null, 4));

        if (!this.isEdit) {
          await this.$apiClient.createWeek(
            this.saveData.season.season_id,
            payload
          );
        } else {
          const updateResult = await this.$apiClient.updateWeek(
            this.saveData.season.season_id,
            payload
          );

          this.setRound(updateResult.data);
        }

        const routeParams = {
          seasonId: this.saveData.season.season_id,
          seasonName: this.saveData.season.name.replace(" ", "-"),
          week: this.saveData.week === 0 ? "bye" : this.saveData.week,
        };
        this.$router.push(
          `/admin/rounds/${routeParams.seasonId}/${routeParams.seasonName}/${routeParams.week}`
        );
        this.resetConfirmDialog();
      } catch (e) {
        this.saveError = e;
      } finally {
        this.enableSaveButton = true;
      }
    },
    resetConfirmDialog() {
      this.saveData = {
        cards: null,
        errorMessages: [],
        playersToCreate: [],
      };
      this.saveError = null;
      this.showConfirmDialog = false;
      this.disableConfirmButton = false;
      this.enableSaveButton = true;
    },
  },
  watch: {
    // call again the method if the route changes
    $route: "init",
  },
  created() {
    this.init();
  },
  destroyed() {},
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.week-score-cards table tbody td {
  padding: 5px !important;
  border: 1px solid #ddd;
}
.week-score-cards table thead tr:first-child th {
  padding: 0 5px !important;
  border: 1px solid #ddd;
}
.week-score-cards table tbody td.total-cell {
  padding-left: 5px !important;
}

.hole-score {
  width: 15px;
}
.ace {
  background-color: #8db5f8;
}

.albatross {
  background-color: #68bd68;
}

.eagle {
  background-color: #7ac47a;
}

.birdie {
  background-color: #9dd49d;
}

.bogey {
  background-color: #e89795;
}

.double-bogey {
  background-color: #df6e6b;
}

.triple-bogey {
  background-color: #da5956;
}
</style>
